export const setGlobalErrors = (errors: any) => {
  return {
    type: 'GLOBAL_ERRORS_SET',
    payload: {
      errors,
    },
  };
};
